const SOAPChangesWarning = () => {
  return (
    <p className="inline-flex items-center px-2 py-1 text-xs font-medium text-red-700 rounded-md bg-red-50 ring-1 ring-inset ring-red-600/50">
      <span>
        Caution: Changes to this wizard will regenerate the corresponding output and may overwrite
        any custom edits.
      </span>
    </p>
  );
};

export default SOAPChangesWarning;
